import { render } from "./DeviceComparisonTable.vue?vue&type=template&id=375477e2"
import script from "./DeviceComparisonTable.vue?vue&type=script&lang=js"
export * from "./DeviceComparisonTable.vue?vue&type=script&lang=js"

import "./DeviceComparisonTable.vue?vue&type=style&index=0&id=375477e2&lang=css"

import exportComponent from "/home/runner/work/customer-interface-v3/customer-interface-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__